var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavSideMenuOverlay'),_c('div',[_c('main',[_c('router-view')],1)]),_c('PageNav'),_c('BackToTop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }